import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import { RenderControlData } from './RenderControlData.js';

const REMARK = [remarkGfm];
const REHYPE = [rehypeSanitize];

function Markdown({ md }) {
  return (
    <div className="prose"> {/* scope your styles */}
      <ReactMarkdown
        remarkPlugins={REMARK}
        rehypePlugins={REHYPE}
        components={{
          // text styles
          p:      ({children}) => <p className="mb-3 leading-relaxed">{children}</p>,
          strong: ({children}) => <span className="font-semibold text-primary text-primary">{children}</span>,
          em:     ({children}) => <em className="italic opacity-90">{children}</em>,
          code:   ({inline, children}) =>
                    inline ? <code className="px-1 rounded">{children}</code>
                           : <pre className="p-3 rounded overflow-x-auto"><code>{children}</code></pre>,

          // headings
          h1: ({children}) => <h1 className="text-2xl font-bold mt-6 mb-3">{children}</h1>,
          h2: ({children}) => <h2 className="text-xl  font-semibold mt-5 mb-2">{children}</h2>,

          // links, lists, quotes, tables
          a:  (props) => <a {...props} className="underline text-blue-600" target="_blank" rel="noreferrer" />,
          ul: ({children}) => <ul className="list-disc pl-6 space-y-1">{children}</ul>,
          blockquote: ({children}) => <blockquote className="border-l-4 pl-3 italic opacity-80">{children}</blockquote>,
          table: ({children}) => <table className="w-full border-collapse">{children}</table>,
          th: ({children}) => <th className="border px-2 py-1 text-left">{children}</th>,
          td: ({children}) => <td className="border px-2 py-1">{children}</td>,
        }}
      >
        {md}
      </ReactMarkdown>
    </div>
  );
}



class MarkdownData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    content: String,
  });
}

export {Markdown,MarkdownData}
export default Markdown;